import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createSponsor, fetchSponsor, updateSponsor } from '../../../api/SponsorsAPI';
import { handleApiError } from '../../../api/risapi';
import { capitalizeFirstLetter } from '../../../commonfunctions';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppToaster from '../../AppToaster';

const SponsorsForm = ({ formType }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = formType === 'edit';

    const [sponsor, setSponsor] = useState({ name: '', contact_person: '', phone_number: '', notes: '' });
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        if (isEditMode && id) {
            fetchSponsor(id, (response) => {
                if (response.sponsor) {
                    setSponsor(response.sponsor);
                }
            });
        }
    }, [id, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSponsor(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (exitForm) => {
        setIsSaving(true);
        setErrors({});
        const apiCall = isEditMode ? updateSponsor : createSponsor;
        apiCall({ ...sponsor, id }, (response) => {
            setIsSaving(false);
            if (response.sponsor) {
                const message = `Sponsor ${isEditMode ? 'updated' : 'created'} successfully!`;
                if (exitForm) {
                    navigate('/club_portal/sponsors', { state: { message } });
                } else {
                    setToaster({ type: 'success', heading: 'Success!', message });
                    setShowToaster(true);
                    setSponsor({ name: '', contact_person: '', phone_number: '', notes: '' }); // Reset form
                }
            } else {
                handleApiError(response, setErrors);
            }
        });
    };

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title={isEditMode ? 'Edit Sponsor' : 'Add New Sponsor'}>
                    <li><a className="f-s-14 f-w-500" href="#">Masters</a></li>
                    <li><a className="f-s-14 f-w-500" href="/club_portal/sponsors">Sponsors</a></li>
                    <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                </AppBreadCrumb>
                <div className="card">
                    <div className="card-header">
                        <h5>{isEditMode ? `Editing: ${sponsor.name}` : 'Sponsor Details'}</h5>
                    </div>
                    <div className="card-body">
                        <form className="app-form">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Sponsor Name *</label>
                                    <input className="form-control" name="name" value={sponsor.name || ''} onChange={handleInputChange} placeholder="Enter sponsor name" />
                                    {errors.name && <div className="text-danger small">{errors.name}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Contact Person</label>
                                    <input className="form-control" name="contact_person" value={sponsor.contact_person || ''} onChange={handleInputChange} placeholder="Enter contact person's name" />
                                    {errors.contact_person && <div className="text-danger small">{errors.contact_person}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Phone Number</label>
                                    <input className="form-control" name="phone_number" value={sponsor.phone_number || ''} onChange={handleInputChange} placeholder="Enter phone number" />
                                    {errors.phone_number && <div className="text-danger small">{errors.phone_number}</div>}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Notes</label>
                                    <textarea className="form-control" name="notes" value={sponsor.notes || ''} onChange={handleInputChange} rows="3" placeholder="Any additional notes about the sponsor..."></textarea>
                                </div>
                                <div className="col-12 text-end">
                                    {!isEditMode ? (
                                        <>
                                            <button type="button" className="btn btn-outline-primary me-2 btn-sm" onClick={() => handleSubmit(false)} disabled={isSaving}>Save + Next</button>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)} disabled={isSaving}>Save + Exit</button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)} disabled={isSaving}>
                                                {isSaving ? 'Updating...' : 'Update Sponsor'}
                                            </button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => navigate('/club_portal/sponsors')}>Cancel</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default SponsorsForm;

